export const removeTypename = <T extends { __typename: string }>(
  value: T
): Omit<T, "__typename"> => {
  const { __typename, ...rest } = value;

  return rest;
};
